import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const getMemberWithLabel = (memberId, memberValue) => {
  // Filter members and assign labels
  const filterMembers = [
    "fund_isin",
    "fund_manager",
    "fund_holdings_count",
    "fund_nav_usd",
    "fund_domicile",
    "fund_esg_rating",
    "esg_environmental_score",
    "esg_social_score",
    "esg_governance_score",
  ]; // add members to filter here
  const labels = [
    "ISIN",
    "Fund Manager",
    "Number of Holdings",
    "Net Asset Value (USD)",
    "Domicile",
    "ESG Rating",
    "ESG Environmental Score",
    "ESG Social Score",
    "ESG Governance Score"
  ]; // add corresponding labels here

  const index = filterMembers.indexOf(memberId);
  if (index !== -1) {
    return { label: labels[index], value: memberValue };
  }
  return null;
};

const KeyFacts = ({ data }) => {
  return (
    <Container>
      <h3>Key Facts</h3>
      {Object.entries(data).map(([key, value], index) => {
        const member = getMemberWithLabel(key, value);
        if (member) {
          return (
            <Row key={index}>
              <Col className="tableitem">{member.label}</Col>
              <Col className="tableitem">{member.value}</Col>
            </Row>
          )
        }
      })}
    </Container>
  );
};

export default KeyFacts;